import { Injectable } from "@angular/core";
import { RidangoReduxAction } from "@ridango/core";

@Injectable({
    providedIn: 'root'
})
export class IsicCardActions {
    static ACTIVATE_ISIC_CARD = '[IsicCard]: Activate Isic Card';
    static ACTIVATE_ISIC_CARD_SUCCESS = '[IsicCard]: Activate Isic Card successful';
    static ACTIVATE_ISIC_CARD_FAILED = '[IsicCard]: Activate Isic Card failed';

    static SET_ISIC_CARD_ACTIVATION_LOADING = '[IsicCard] Set Isic Card activation loading';

    activateIsicCard(payload: any): RidangoReduxAction {
        return {
            type: IsicCardActions.ACTIVATE_ISIC_CARD,
            payload: payload,
        };
    }

    activateIsicCardSuccess(payload: any): RidangoReduxAction {
        return {
            type: IsicCardActions.ACTIVATE_ISIC_CARD_SUCCESS,
            payload: payload,
        };
    }

    activateIsicCardFailed(error: any): RidangoReduxAction {
        return {
            type: IsicCardActions.ACTIVATE_ISIC_CARD_FAILED,
            payload: error,
        };
    }

    activateIsicCardLoading(loading: boolean): RidangoReduxAction {
        return {
            type: IsicCardActions.SET_ISIC_CARD_ACTIVATION_LOADING,
            payload: loading,
        };
    }

    setIsicCardActivationLoading(loading: boolean): RidangoReduxAction {
        return {
            type: IsicCardActions.SET_ISIC_CARD_ACTIVATION_LOADING,
            payload: loading,
        };
    }
}